import { useShowHpaV2 } from './permissions/useShowHpaV2';
import { useVersionsInfo } from './useVersionsInfo';

/**
 * HPA Version Status
 * - 'loading': woopVersionLoading === true
 * - 'error': woopVersionError === true
 * - 'disabled': showHpaV2 === false
 * - 'outdated': showHpaV2 === true && isNativeHpaCannotBeUsed === true
 * - 'available': showHpaV2 === true && isNativeHpaCannotBeUsed === false
 */
export type HpaV2Status =
  | 'loading'
  | 'error'
  | 'disabled'
  | 'outdated'
  | 'available';

export const useHpaV2Status = (): { hpaV2Status: HpaV2Status } => {
  const { showHpaV2 } = useShowHpaV2();
  const { isNativeHpaCannotBeUsed, woopVersionLoading, woopVersionError } =
    useVersionsInfo();

  if (woopVersionLoading) {
    return { hpaV2Status: 'loading' };
  }

  if (woopVersionError) {
    return { hpaV2Status: 'error' };
  }

  if (!showHpaV2) {
    return { hpaV2Status: 'disabled' };
  }

  if (isNativeHpaCannotBeUsed) {
    return { hpaV2Status: 'outdated' };
  }

  return { hpaV2Status: 'available' };
};
